import LockTableRow from "./LockTableRow";
import UserNameCellRenderer from "../renderers/UserNameCellRenderer";
import OvertimeRow from "./OvertimeRow";
import UserLeavesRow from "./UserLeavesRow";
import UserDayCellRenderer from "../renderers/UserDayCellRenderer";

export default class UserRow extends LockTableRow {
    constructor(userId, expandedUsersStorage, today, workdayDurations) {
        super();
        this.childRows = [];
        this.userId = userId;
        this.expandedUsersStorage = expandedUsersStorage;
        this.expanded = expandedUsersStorage.contains(userId);
        this.expandCollapseDisabled = false;
        this.expandCollapseListeners = [];
        this.today = today;
        this.workdayDurations = workdayDurations;
    }

    createRowHeaderRenderer() {
        return new UserNameCellRenderer();
    }

    createLockCellRenderer() {
        return new UserDayCellRenderer();
    }

    disableExpandCollapse(disable) {
        this.expandCollapseDisabled = disable;
    }

    addExpandCollapseListener(listener) {
        this.expandCollapseListeners.push(listener);
    }

    isExpanded() {
        return this.expanded;
    }

    addChildRow(row) {
        this.childRows.push(row);
        row.setParentRow(this);
        row.setTable(this.getTable());
        row.showHide(this.expanded);
        if (row instanceof OvertimeRow && !this.overtimeRow)
            this.overtimeRow = row;
    }

    getChildRows() {
        return this.childRows;
    }

    getLastChildRow() {
        if (this.childRows.length > 0)
            return this.childRows[this.childRows.length - 1];
        else
            return null;
    }

    expand() {
        if (!this.expanded)
            this.changeExpandCollapse();
    }

    collapse() {
        if (this.expanded)
            this.changeExpandCollapse();
    }

    changeExpandCollapse() {
        if (this.childRows.length == 0 || this.expandCollapseDisabled)
            return;

        this.expanded = !this.expanded;

        if (this.expanded)
            this.expandedUsersStorage.add(this.userId);
        else
            this.expandedUsersStorage.remove(this.userId);

        this.updateUI();
        for (var i = 0; i < this.expandCollapseListeners.length; i++) {
            this.expandCollapseListeners[i](this);
        }
    }

    accept(visitor, cell) {
        return visitor.visitUserRow(cell);
    }

    updateUI() {
        for (var i = 0; i < this.childRows.length; i++) {
            this.childRows[i].showHide(this.expanded);
        }

        for (i = 0; i < this.cells.length; i++) {
            this.updateCellUI(i);
        }
    }

    createUserLeavesRow(headerText) {
        this.userLeavesRow = new UserLeavesRow();
        this.userLeavesRow.addCell(headerText);
        this.addChildRow(this.userLeavesRow);
        this.getTable().addRow(this.userLeavesRow);
        return this.userLeavesRow;
    }

    getUserLeavesRow() {
        return this.userLeavesRow;
    }

    getUserLeaveInfo(cellIdx) {
        if (this.userLeavesRow)
            return this.userLeavesRow.getCell(cellIdx).getValue();

        return {time: 0, leaveInfo: undefined};
    }

    getUserOvertimeInfo(cellIdx) {
        if (this.overtimeRow)
            return this.overtimeRow.getCell(cellIdx).getValue();
        else
            return 0;
    }

    isTodayCell(cell) {
        return this.getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date.getTime() == this.today.getTime();
    }

    isHolidayCell(cell) {
        return this.workdayDurations[cell.getColIdx() - 1] == 0; // -1 because of one header column
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/UserRow.js